import * as React from "react";
import { ThemeProvider } from "styled-components";
import "@fontsource/karla"
import 'mapbox-gl/dist/mapbox-gl.css';

import Body from "@/components/core-blocks/Body";
import CookieConsent from "@/components/core-blocks/CookieConsent";
import Footer from "@/components/core-blocks/Footer";

import Header from "@/components/core-blocks/Header";
import Main from "@/components/core-blocks/Main";
import Seo, { SEOProps } from "@/components/core-blocks/Seo";
import Flexible, { IFlexible } from "@/src/components/core-blocks/Flexible";
import GlobalStyle from "@/styles/global";
// import { IPageSettings } from "../types";
import defaultTheme from "@/styles/themes/default.theme";
import { LocalizationProvider } from "../contexts/Localization";
import { PageProps } from "gatsby";
import { IPageSettings, IPostTypeContext } from "../types";

import AOS from 'aos';
import 'aos/dist/aos.css';

export interface IPageContext extends IPostTypeContext {
  acf: IFlexible;
  seo: SEOProps;
  title: string;
}

export interface IPageTemplate
  extends PageProps<object, object, { scrollPosition: number }> {
  pageContext: IPageContext;
}

const PageTemplate: React.FC<IPageTemplate> = ({
  pageContext: { seo, acf, ...pageContext },
  location,
}) => {
  
  React.useEffect(() => {
    if (typeof window !== "undefined") {
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 10);
    }

    AOS.init({
      duration: 1000,
    });
  }, []);

  return (
    <LocalizationProvider
      language={pageContext.language.slug}
      translations={pageContext.translations}
      >
      <ThemeProvider theme={defaultTheme}>
        <GlobalStyle />
        <Seo {...seo} />

        {/* Boxicons 2.0.7 */ }
        <link href='https://unpkg.com/boxicons@2.0.7/css/boxicons.min.css' rel='stylesheet' />

        <Body>
          <Header />
          <Main>
            <Flexible components={pageContext.flexible.components} />
            <Footer />
          </Main>
        </Body>
      </ThemeProvider>
    </LocalizationProvider>
  );
};

export default PageTemplate;
